module.exports = __webpack_public_path__ + "static/media/netflix-card.68bdf0fd.svg";